module.exports = __webpack_public_path__ + "img/imprimir.a6c08d11.png";